import './searchWrapper.css';

var styles = {"wrapper":"wrapper__3NUs2","categoryWrapper":"categoryWrapper__1B5xt","noScroll":"noScroll__1WTag"};

export { styles as default };
